export default "__VITE_PUBLIC_ASSET__b1037904__"